import taskManagerApi from '@/features/shared/services/taskManagerApi';
export const login = async (credentials) => {
    const res = await taskManagerApi.post('/auth/login', credentials);
    return res.data;
};
export const logout = async () => {
    return taskManagerApi.post('/auth/logout');
};
export const verifyTwoFactor = (payload) => taskManagerApi.post('/auth/verify-2fa', payload);
export const resendTwoFactor = (email) => taskManagerApi.post('/auth/resend-2fa', { email });
export const forgotPassword = (email) => taskManagerApi.post('/auth/forgot-password', { email });
export const resetPassword = (token, newPassword) => taskManagerApi.post('/auth/reset-password', { token, newPassword });
export const fetchCurrentUser = async () => {
    try {
        const res = await taskManagerApi.get('/auth/me', { withCredentials: true });
        return res.data.data;
    }
    catch (error) {
        if (error instanceof Error) {
            console.log(error);
            const serverError = error?.response?.data?.error;
            throw new Error(serverError?.details ?? serverError?.message ?? error.message);
        }
        else {
            throw new Error("Erreur inconnue lors de la récupération de l'utilisateur connecté.");
        }
    }
};
